import { Component, ViewChild, ChangeDetectorRef } from "@angular/core";
import { ListWindow, PageService, TabComponent } from "@xo/client-common";
import { Type11FileTable } from "./type11File.table";

@Component({
  selector: "spec-app-type11-file-list-window",
  templateUrl: "./type11File.list.html",
  styleUrls: ["./type11File.list.scss"]
})
export class Type11FileListWindowComponent extends ListWindow {

  @ViewChild("table", { static: false }) table: Type11FileTable;

  clickHandler: Function;

  constructor(changeDetectorRef: ChangeDetectorRef, private tab: TabComponent, public pageService: PageService) {
    super(changeDetectorRef);
  }

  init(filters?) {
    this.clickHandler = this.pageService.createOpenObject(
      "SpecApp/Type11FilePage",
      this.tab.system,
      (object) => `Type11File at ID:${object ? object.id : null}`,
      () => ({})
    );
    super.init(filters, this.table);
  }

  reload() {
    console.log("Type11FileList reload");
    super.reload();
    this.table.refreshList();
  }
}
